import { render } from "./PaginationDefault.vue?vue&type=template&id=a88d056c&scoped=true&ts=true"
import script from "./PaginationDefault.vue?vue&type=script&lang=ts"
export * from "./PaginationDefault.vue?vue&type=script&lang=ts"

import "./PaginationDefault.vue?vue&type=style&index=0&id=a88d056c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88d056c"]])

export default __exports__